import { AggRelayEnvironment, createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router';
import { isGateEnabled } from '@townsquare/stat-sig/gate';

import useLabelFeedPostsQuery, {
  type useLabelFeedPostsQuery as useLabelFeedPostsQueryType,
} from '../hooks/__generated__/useLabelFeedPostsQuery.graphql';
import { Timeframe, getDiscoverTab, getTimeframe } from '../types';

const timeframeMap: Record<Timeframe, string> = {
  day: '-1d',
  week: '-1w',
  default: '-2w',
  month: '-30d',
  year: '-1y',
};

export const labelFeedResource = createRelayResource<useLabelFeedPostsQueryType>({
  getQuery: (routerContext, resourceStoreContext) => {
    const context = resourceStoreContext as ResourceContext;

    const timeframe = getTimeframe(routerContext.query.timeGranularity);

    const tabName = getDiscoverTab(routerContext.query.tab);
    const label = tabName === 'welcome' ? 'welcome-blog' : tabName === 'farewell' ? 'farewell-blog' : '';

    const isEnabled =
      !!context.collabContext?.rovoWorkspace &&
      isGateEnabled('townsquare_enable_popular_feed') &&
      isGateEnabled('townsquare_enable_popular_tabs') &&
      tabName !== 'popular' &&
      !!label;

    const cqlQuery = `label = "${label}" AND created > now("${timeframeMap[timeframe]}") order by created desc`;

    return {
      query: useLabelFeedPostsQuery,
      variables: {
        cloudId: context.collabContext?.rovoWorkspace,
        cqlQuery,
        isEnabled,
      },
      environment: AggRelayEnvironment,
    };
  },
  maxAge: 60_000 * 30, // 30 minute cache during the SPA session to avoid flickering
});
